
import {  AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { DataTableDirective } from 'angular-datatables';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { FormatDataTableGlobal } from 'src/app/web/util/formatDataTable';
import { ApiServiceERP } from 'src/app/web/apis/ApiServiceERP';
import { ErrorService } from 'src/app/shared/services/errors.service';

export class listClient {

  name_client: string;
  user_id:number
  listHeadquarter: 
  {
    name: string;
  };
  
}


@Component({
  selector: 'app-create-client',
  templateUrl: './create-client.component.html',
  styleUrls: ['./create-client.component.scss']
})
export class CreateClientComponent implements  AfterViewInit, OnDestroy, OnInit  {

  @ViewChild(DataTableDirective, {static: false})
  
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtOptions2: DataTables.Settings = {};
  annex: any[] = []
  annexForm: FormGroup;
  step:number = 0
  title="Datos"
  createClient: listClient;
  items!: FormArray;
  paymentsform: FormGroup;
  createClientForm: FormGroup;
  listUser: any[] = [];
  permiso: number[] = []
  name_vacio: number[] = [];
  name_vacio2: number[] = [];
  constructor(
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private apiService: ApiServiceERP,
    private errorService:ErrorService,
  ) { 
   
  }

  ngOnInit(): void {
    // this.permiso = this.errorService.getPermisses();
    // if (this.permiso.find(element => element == 15)) {
    // }  else {
    //   this.errorService.error2(403)
    //   this.spinner.hide();
    // } 
    this.serviceListUser()
    this.paymentsform = this.fb.group({
      items: new FormArray([])
    });

    this.createClientForm = this.fb.group({
      name_client: [''],
      listHeadquarter: [],
      user_id: [null],
    });

    this.items = this.paymentsform.get("items") as FormArray

    let info = this.fb.group({
      name: "",
    });

    this.items.push(info)

    
  }

  serviceListUser(){

        this.apiService.getService('user-list').subscribe({
          next: (rs:any) => {
            if (rs.code == null) {
              // si la respuesta no tiene error pero no tiene data se manda un mensaje de error y se retorna al home
              if (rs == '' || rs == null) {
                this.spinner.hide();
                Swal.fire({
                  title: 'No se encontraron registros',
                  text: '',
                  icon: 'info',
                  confirmButtonText: 'Aceptar',
                  heightAuto: false
                }).then((res) => {
                  if (res.isConfirmed || res.isDismissed) {
                  }
                });
              }
              this.listUser = rs
              this.spinner.hide();
            } else {
              this.spinner.hide();
              Swal.fire({
                title:  rs.error,
                text: '',
                icon: 'error',
                heightAuto: false
                });
            }
          },
          error: (error) => {
            this.errorService.error(error);
          },
        });
  }
  

  eliminarCampo(index) {
    this.items.removeAt(index)
    }
 
    ngAfterViewInit(): void {
    
  }

  ngOnDestroy(): void {
    
  }

  rerender(): void {
    
    
  }

  nuevoCampo() {
    this.items = this.paymentsform.get("items") as FormArray
    let info = this.fb.group({
      name: "",
    });

    this.items.push(info)

  }

  formSubmit(): void {

    if(this.createClientForm.value.name_client == ""){
      Swal.fire({title:"Debe selecciona un nombre" ,text: '',icon: 'error',heightAuto: false});
      return;
    }

    if(this.createClientForm.value.user_id == null){
      Swal.fire({title:"Debe selecciona un lider" ,text: '',icon: 'error',heightAuto: false});
      return;
    }
 

    if(this.items.value.find(x => x.name == "")){
      Swal.fire({title:"Todas las sucursales deben contener el nombre" ,text: '',icon: 'error',heightAuto: false});
      return;
    }
  
   

    this.spinner.show();
    

    this.createClient = this.createClientForm.value;
    this.createClient.name_client = this.createClientForm.value.name_client;
    this.createClient.listHeadquarter = this.items.value;
    this.createClient.user_id = this.createClientForm.value.user_id;

   
    this.apiService.postService('client-insert', this.createClient)
      .subscribe({
        next: (data: any) => {
          this.spinner.hide();
          Swal.fire({title:'Se ha ingresado correctamente',text: '',icon: 'success',heightAuto: false})
            .then(() => {
              this.router.navigate(['/pdg/client/list/']);
            });
          
        },
        error: (error) => {
          this.errorService.error(error);
        }
      });
  }
}
